export default {
  male: [
    {
      value: `boyfriend`,
      label: `Любимому`
    },
    {
      value: `brother`,
      label: `Брату`
    },
    {
      value: `husband`,
      label: `Мужу`
    },
    {
      value: `son`,
      label: `Сыну`
    },
    {
      value: `grandpa`,
      label: `Дедушке`
    },
    {
      value: `friend`,
      label: `Другу`
    },
    {
      value: `father`,
      label: `Папе`
    },
    {
      value: `director`,
      label: `Начальнику`
    }
  ],
  female: [
    {
      value: `girlfriend`,
      label: `Любимой`
    },
    {
      value: `sister`,
      label: `Сестре`
    },
    {
      value: `wife`,
      label: `Жене`
    },
    {
      value: `daughter`,
      label: `Дочке`
    },
    {
      value: `grandma`,
      label: `Бабушке`
    },
    {
      value: `femalefriend`,
      label: `Подруге`
    },
    {
      value: `mother`,
      label: `Маме`
    },
    {
      value: `femaledirector`,
      label: `Начальнице`
    }
  ]
};
